// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__YU9YQ","requiredAsterisk":"Info_requiredAsterisk__3izm4"};